module.exports = {
	"library.footer.terms_of_use": "Terms of Use",
	"library.footer.terms_and_conditions": "Terms and Conditions",
	"library.footer.privacy_policy": "Privacy Policy",
	"library.footer.get_to_know_us": "Get to know us",
	"library.footer.about": "About",
	"library.footer.jobs": "Jobs",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Get help",
	"library.footer.find_events": "Find events",
	"library.footer.top_events": "Top events",
	"library.footer.host_events": "Host events",
	"library.footer.become_a_host": "Become a host",
	"library.footer.tour": "Tour",
	"library.footer.embeddable_widgets": "Embeddable Widgets",
	"library.footer.customers": "Customers",
	"library.footer.pricing": "Pricing",
	"library.footer.get_the_onsite_app": "Get the onsite app",
	"library.footer.developers": "Developers",
	"library.footer.contact_us": "Contact us"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/en.json
// module id = 1577
// module chunks = 0 1 2 3 5 6 7 8 9 10 11 12 13 14 15 16